import { LogisticAsyncTaskEntityType } from '../logistic-async-task.types';

export const LogisticRequestShortCarModelTask = {
  entityType: LogisticAsyncTaskEntityType.Request,
  type: 'calculateShortCarModel',
  stages: {
    Calculate: 'calculate',
    DispatchWebhook: 'dispatchWebhook',
  },
} as const;

export type LogisticRequestCalculateShortCarModelPayload = {
  carModel: string | null;
  carModelAndBrand: string | null;
  carBrandName: string | null;
  resolvedCarBrandName: string | null;
  carName: string | null;
  carBrandId: number | null;
};

export type LogisticRequestShortCarModelTaskDefinition = {
  entityType: typeof LogisticRequestShortCarModelTask.entityType;
  entityId: number;
  type: typeof LogisticRequestShortCarModelTask.type;
  stage: typeof LogisticRequestShortCarModelTask.stages.Calculate;
  payload: LogisticRequestCalculateShortCarModelPayload;
};
